<template>
  <div class="lifecycle-emissions">
    <div class="emissions-grid">
      <!-- 左列 -->
      <div class="emissions-column">
        <template
          v-for="(item, index) in emissionsData.lifeCarbonList"
        >
          <div
            v-if="item.stageType % 2 !== 0"
            :key="index"
            class="emission-stage"
          >
            <div class="stage-label">
              <span
                v-if="info[item.stageType] && info[item.stageType].require"
                class="required"
                >*</span
              >
              <!-- {{ info[item.stageType] && info[item.stageType].title }} -->
              <span
                v-html="info[item.stageType] && info[item.stageType].title"
              ></span>
            </div>
            <div class="stage-inputs">
              <div class="input-group">
                <span
                  v-if="info[item.stageType] && info[item.stageType].require"
                  class="require-label"
                  >*</span
                >
                <label>碳排放量</label>
                <el-input
                  v-model="item.carbonEmission"
                  :class="[
                    info[item.stageType].Name ? info[item.stageType].Name : '',
                  ]"
                  maxlength="100"
                  class="emissions"
                  placeholder="请输入"
                  @input="(val) => handleInput(val, index)"
                />
              </div>
              <div class="input-group">
                <label>占比</label>
                <el-input
                  v-model="item.proportion"
                  maxlength="100"
                  class="proportion"
                  placeholder="请输入"
                  @input="(val) => handleInputProportion(val, index)"
                ></el-input>
                <i class="unit">%</i>
              </div>
            </div>
          </div>
        </template>
      </div>

      <!-- 分隔线 -->
      <div class="divider"></div>

      <!-- 右列 -->
      <div class="emissions-column">
        <template
          v-for="(item, index) in emissionsData.lifeCarbonList"
        >
          <div
            v-if="item.stageType % 2 === 0"
            :key="index"
            class="emission-stage"
          >
            <div class="stage-label">
              <span
                v-if="info[item.stageType] && info[item.stageType].require"
                class="required"
                >*</span
              >
              <span
                v-html="info[item.stageType] && info[item.stageType].title"
              ></span>
            </div>
            <div class="stage-inputs">
              <div class="input-group">
                <label>碳排放量</label>
                <el-input
                  v-model="item.carbonEmission"
                  :class="[
                    info[item.stageType].Name ? info[item.stageType].Name : '',
                  ]"
                  maxlength="100"
                  class="emissions"
                  placeholder="请输入"
                  @input="(val) => handleInput(val, index)"
                />
              </div>
              <div class="input-group">
                <label>占比</label>
                <el-input
                  v-model="item.proportion"
                  maxlength="100"
                  class="proportion"
                  placeholder="请输入"
                  @input="(val) => handleInputProportion(val, index)"
                ></el-input>
                <i class="unit">%</i>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- 碳排放总量 -->
    <div class="total-emission">
      <div class="total-label"><span class="required">*</span>碳排放总量</div>
      <div class="total-input">
        <el-input
          v-model="emissionsData.carbonTotal"
          class="require4"
          maxlength="100"
          placeholder="请输入碳排放总量"
          @input="handleInputTotal"
        />
      </div>
    </div>
  </div>
</template>

<script>
const info = {
  1: {
    title: '原材料获取阶段<br/>（上游生产）',
    require: false,
  },
  2: {
    title: '原材料获取阶段<br/>（运输）',
    require: false,
    Name: 'require1',
  },
  3: {
    title: '生产阶段',
    require: true,
    Name: 'require2',
  },
  4: {
    title: '运输（交付）阶段',
    require: false,
    Name: 'require3',
  },
  5: {
    title: '使用阶段',
    require: false,
  },
  6: {
    title: '生命末期阶段',
    require: false,
  },
};

export default {
  name: 'LifecycleEmissions',
  props: {
    emissions: {
      type: Object,
      default: () => ({
        // rawMaterialAcquisition: { carbonEmission: '', proportion: '' },
        // productionManufacturing: { carbonEmission: '', proportion: '' },
        // productUse: { carbonEmission: '', proportion: '' },
        // rawMaterialTransportation: { carbonEmission: '', proportion: '' },
        // productionTransportation: { carbonEmission: '', proportion: '' },
        // wasteDisposal: { carbonEmission: '', proportion: '' },
        lifeCarbonList: [
          { stageType: 1, carbonEmission: '', proportion: '' },
          { stageType: 2, carbonEmission: '', proportion: '' },
          { stageType: 3, carbonEmission: '', proportion: '' },
          { stageType: 4, carbonEmission: '', proportion: '' },
          { stageType: 5, carbonEmission: '', proportion: '' },
          { stageType: 6, carbonEmission: '', proportion: '' },
        ],
        carbonTotal: '',
      }),
    },
  },
  data() {
    return {
      info,
      emissionsData: {
        // rawMaterialAcquisition: { carbonEmission: '', proportion: '' },
        // productionManufacturing: { carbonEmission: '', proportion: '' },
        // productUse: { carbonEmission: '', proportion: '' },
        // rawMaterialTransportation: { carbonEmission: '', proportion: '' },
        // productionTransportation: { carbonEmission: '', proportion: '' },
        // wasteDisposal: { carbonEmission: '', proportion: '' },
        lifeCarbonList: [
          { stageType: 1, carbonEmission: '', proportion: '' },
          { stageType: 2, carbonEmission: '', proportion: '' },
          { stageType: 3, carbonEmission: '', proportion: '' },
          { stageType: 4, carbonEmission: '', proportion: '' },
          { stageType: 5, carbonEmission: '', proportion: '' },
          { stageType: 6, carbonEmission: '', proportion: '' },
        ],
        carbonTotal: '',
      },
    };
  },
  watch: {
    emissionsData: {
      handler(newVal) {
        // console.log(newVal)
        this.$emit('input', {
          lifeCarbonList: newVal.lifeCarbonList,
          carbonTotal: newVal.carbonTotal,
        });
      },
      deep: true,
    },
  },
  mounted() {
    const { lifeCarbonList, carbonTotal } = this.emissions;
    console.log(this.emissions,123123213)
    this.emissionsData = {
      lifeCarbonList,
      carbonTotal,
    };
  },
  methods: {
    handleInput(val, index) {
      const clean = val
        .replace(/[^\d.]/g, '') // 只能数字和 .
        .replace(/^(\d*\.\d*?)\..*$/, '$1') // 只保留一个小数点
        .replace(/^0+(\d)/, '$1'); // 避免开头多个0
      this.emissionsData.lifeCarbonList[index].carbonEmission = clean;
    },
    handleInputTotal(val) {
      const clean = val
        .replace(/[^\d.]/g, '') // 只能数字和 .
        .replace(/^(\d*\.\d*?)\..*$/, '$1') // 只保留一个小数点
        .replace(/^0+(\d)/, '$1'); // 避免开头多个0
      this.emissionsData.carbonTotal = clean;
    },
    handleInputProportion(val, index) {
      const clean = val
        .replace(/[^\d.]/g, '') // 只能输入数字和 .
        .replace(/^(\d*\.\d*?)\..*$/, '$1') // 只保留一个小数点
        .replace(/^0+(\d)/, '$1'); // 避免开头多个0

      // 允许输入 "." 或 "0." 这种未完整的小数
      if (clean === '.' || clean === '0.') {
        this.emissionsData.lifeCarbonList[index].proportion = clean;
        return;
      }

      if (clean > 100) {
        this.emissionsData.lifeCarbonList[index].proportion = '100';
        return;
      }

      // 最终写回（保留原始输入的小数位，避免 1. → 1 这种情况）
      this.emissionsData.lifeCarbonList[index].proportion = clean;
    },

    calculateTotal() {
      // let total = 0;
      // const stages = [
      //   'rawMaterialAcquisition',
      //   'productionManufacturing',
      //   'productUse',
      //   'rawMaterialTransportation',
      //   'productionTransportation',
      //   'wasteDisposal',
      // ];
      // stages.forEach((stage) => {
      //   const emission = parseFloat(this.emissionsData[stage].carbonEmission) || 0;
      //   total += emission;
      // });
      // this.emissionsData.carbonTotal = total.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.lifecycle-emissions {
  border: 1px solid #d9d9d9;
}

.emissions-grid {
  display: flex;
  // gap: 20px;
}

.emissions-column {
  // padding: 10px 0px;
  flex: 1;
  display: flex;
  flex-direction: column;
  // gap: 15px;
}

.divider {
  width: 1px;
  background: #d9d9d9;
}

.emission-stage {
  height: 50px;
  display: flex;
  align-items: center;
}

.stage-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  width: 152px;
  text-align: right;
  padding: 0px 20px 0px 0px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  line-height: 1.2;
  margin-right: 20px;
  border-right: 1px solid #d9d9d9;
  background: #f8f8f8;
  // margin-bottom: 10px;
}

.stage-inputs {
  display: flex;
  height: 30px;
  align-items: center;
  gap: 20px;
}

.input-group {
  display: flex;
  line-height: 30px;
  position: relative;
  align-items: center;
  .require-label {
    position: absolute;
    color: #f0250f;
    left: -8px;
    top: 0px;
  }
  label {
    display: block;
    line-height: 1.2;
    font-size: 14px;
    color: #666;
    margin-right: 10px;
    // margin-bottom: 5px;
  }
  .emissions {
    max-width: 102px;
    width: auto;
  }
  .proportion {
    max-width: 80px;
    width: auto;
  }
}

.total-emission {
  border-top: 1px solid #d9d9d9;

  display: flex;
  align-items: center;
}

.total-label {
  font-size: 14px;
  font-weight: 500;
  height: 50px;
  width: 152px;
  text-align: right;
  padding-right: 20px;
  background: #f8f8f8;
  // text-align: center;
  line-height: 50px;
  white-space: nowrap;
}

.total-input {
  flex: 1;
  height: 50px;
  display: flex;
  background: #f8f8f8;
  align-items: center;
  padding-right: 22px;
}
.required {
  color: #f0250f;
}
::v-deep .el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}
.unit {
  color: #333;
  margin-left: 8px;
}
</style>
